const MOBILE_MENU_MQ = window.matchMedia('(max-width: 1023px)');

/**
 * Toggle the compact header drawer with nav and tools.
 *
 * @return {void}
 */
export function initHeaderMobileMenu() {
	const header = document.querySelector('[data-header]');
	const toggle = document.querySelector('[data-header-menu-toggle]');
	const panel = document.querySelector('[data-header-mobile-menu]');

	if (!header || !toggle || !panel) {
		return;
	}

	const openLabel = toggle.dataset.labelOpen || 'Open menu';
	const closeLabel = toggle.dataset.labelClose || 'Close menu';

	const isMobile = () => MOBILE_MENU_MQ.matches;

	const bar = header.querySelector('.header__bar');

	const updateOffset = () => {
		if (!bar) {
			return;
		}

		const { bottom } = bar.getBoundingClientRect();
		const offset = `${Math.ceil(bottom)}px`;

		header.style.setProperty('--header-mobile-offset', offset);
		document.documentElement.style.setProperty('--header-mobile-offset', offset);
	};

	const syncPanelAccessibility = (isOpen) => {
		if (!isMobile()) {
			panel.inert = false;
			panel.removeAttribute('inert');
			panel.setAttribute('aria-hidden', 'false');

			return;
		}

		panel.inert = !isOpen;
		panel.setAttribute('aria-hidden', String(!isOpen));
	};

	const setOpen = (isOpen) => {
		if (!isMobile()) {
			isOpen = false;
		}

		header.classList.toggle('is-menu-open', isOpen);
		document.body.classList.toggle('is-header-menu-open', isOpen);
		toggle.setAttribute('aria-expanded', String(isOpen));
		toggle.setAttribute('aria-label', isOpen ? closeLabel : openLabel);
		syncPanelAccessibility(isOpen);

		if (isOpen) {
			updateOffset();
		}
	};

	toggle.addEventListener('click', () => {
		if (!isMobile()) {
			return;
		}

		setOpen(!header.classList.contains('is-menu-open'));
	});

	panel.addEventListener('click', (event) => {
		const link = event.target.closest('a');

		if (!link || !panel.contains(link)) {
			return;
		}

		const parentItem = link.closest('.menu-item-has-children');

		if (parentItem && parentItem.querySelector(':scope > a') === link) {
			return;
		}

		setOpen(false);
		toggle.focus();
	});

	document.addEventListener('keydown', (event) => {
		if ('Escape' !== event.key || !header.classList.contains('is-menu-open')) {
			return;
		}

		setOpen(false);
		toggle.focus();
	});

	MOBILE_MENU_MQ.addEventListener('change', () => {
		setOpen(false);
		syncPanelAccessibility(false);
	});

	window.addEventListener('resize', () => {
		if (header.classList.contains('is-menu-open')) {
			updateOffset();
		}
	});

	window.addEventListener(
		'orientationchange',
		() => {
			if (header.classList.contains('is-menu-open')) {
				window.requestAnimationFrame(updateOffset);
			}
		},
		{ passive: true }
	);

	syncPanelAccessibility(false);
}
